/*
 *  -----------------------------------------------------------------------
 *    <copyright file="manage-signatories/index.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import ManageSignatories from '@pages/shared/manage-signatories/manage-signatories';

export default ManageSignatories;
